export const INFO_URL =
  "https://developer.intuit.com/app/developer/qbo/docs/get-started/get-client-id-and-client-secret";
